var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"main-wrapper"},[_c('sidebar-component',{attrs:{"classMenu":"MprPengajuan"}}),_c('div',{staticClass:"page-wrapper"},[_c('navbar-component'),_c('router-view'),_c('footer-component')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }